import React from "react";

interface ISocialMediaLink {
  label: string;
  url: string;
  image: string;
}

const SocialMediaLink = ({ label, url, image }: ISocialMediaLink) => {
  if (!url || !image) return null;

  return (
    <li>
      <a
        className="h-[27px] w-[27px] flex items-center justify-center rounded-full border-1 border-grey-800"
        href={url}
        aria-label={label}
        target="_blank"
        rel="noreferrer"
      >
        <img src={image} alt={label} />
      </a>
    </li>
  );
};

export default SocialMediaLink;
